"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublicProgramContentLink = exports.getProgramContentLink = exports.getTaskFromElement = exports.getTask = exports.hasElementSetting = void 0;
var constants_1 = require("./constants");
var stringUtils_1 = require("../youwell-common/stringUtils");
var urls_1 = __importDefault(require("../app/urls"));
var taskContentUtils_1 = require("./taskContentUtils");
// Optionally including label search for backward compatibility
var hasElementSetting = function (element, requiredSetting, includeLabelSearch) {
    var _a;
    if (includeLabelSearch === void 0) { includeLabelSearch = false; }
    return ((_a = element
        .settings) === null || _a === void 0 ? void 0 : _a.some(function (e) { return e === requiredSetting; }))
        || (includeLabelSearch && element.label === requiredSetting);
};
exports.hasElementSetting = hasElementSetting;
var getTaskWithDetails = function (element, task, patientProgramId, elementIndex, elementGroupLength, subIndex) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (elementIndex === void 0) { elementIndex = 0; }
    if (elementGroupLength === void 0) { elementGroupLength = 0; }
    if (subIndex === void 0) { subIndex = 0; }
    var elementGroup = element.elementGroup;
    var listLength = element.module ? element.module.tasks.length : elementGroupLength;
    var isSeparateItemsInModule = (0, stringUtils_1.parseBoolString)((_b = (_a = element.module) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b['separate-items']);
    var noSideMenu = (0, stringUtils_1.parseBoolString)((_d = (_c = element.module) === null || _c === void 0 ? void 0 : _c.settings) === null || _d === void 0 ? void 0 : _d['no-side-menu']);
    var isWorkSheet = (0, exports.hasElementSetting)(element, constants_1.patientProgramAppElementSettings.worksheet) || (0, stringUtils_1.parseBoolString)((_e = task.settings) === null || _e === void 0 ? void 0 : _e.worksheet);
    var showCompleteButtonForAppItems = (0, stringUtils_1.parseBoolString)((_g = (_f = element.module) === null || _f === void 0 ? void 0 : _f.settings) === null || _g === void 0 ? void 0 : _g['show-complete-button']);
    var isSubmitTask = (0, stringUtils_1.parseBoolString)((_h = task.settings) === null || _h === void 0 ? void 0 : _h.submit); // set if task should send submit=true on "Next"/"Send" action
    var showNextPrevNavigation = Boolean(element.module && !isSeparateItemsInModule);
    var showHomeNavigation = !isSeparateItemsInModule && listLength === 1;
    var showBackNavigation = isSeparateItemsInModule;
    var showCompleteNavigation = !isSeparateItemsInModule;
    var hidePrevNavigationIfFirstTask = false;
    var saveAndAbortNavigation = false;
    var redirectHomeAfterLastTask = false;
    var showPopupAfterLastTask = false;
    var showSideMenu = !noSideMenu && Boolean((_k = (_j = element.module) === null || _j === void 0 ? void 0 : _j.tasks) === null || _k === void 0 ? void 0 : _k.length);
    var showProgress = false;
    var showFavourite = false;
    if (elementGroup === constants_1.patientProgramElementGroups.main) {
        showPopupAfterLastTask = false;
        showNextPrevNavigation = true;
        showProgress = false;
        showFavourite = true;
    }
    else if (elementGroup === constants_1.patientProgramElementGroups.scheduled) {
        showNextPrevNavigation = listLength > 1;
        redirectHomeAfterLastTask = true;
        saveAndAbortNavigation = true;
        showSideMenu = false;
        showProgress = true;
        isSubmitTask = ((_l = task.settings) === null || _l === void 0 ? void 0 : _l.submit) !== undefined ? isSubmitTask : !!element.task; // use setting if present otherwise always true for single Task
    }
    else if (elementGroup === constants_1.patientProgramElementGroups.app) {
        showHomeNavigation = true;
        showFavourite = true;
        showCompleteNavigation = showCompleteButtonForAppItems || false;
    }
    else if (elementGroup === constants_1.patientProgramElementGroups.consent) {
        showNextPrevNavigation = true;
        showHomeNavigation = false;
        hidePrevNavigationIfFirstTask = true;
        redirectHomeAfterLastTask = true;
        showSideMenu = false;
        showProgress = true;
        isSubmitTask = ((_m = task.settings) === null || _m === void 0 ? void 0 : _m.submit) !== undefined ? isSubmitTask : !!element.task; // use setting if present otherwise always true for single Task
    }
    else if (elementGroup === constants_1.patientProgramElementGroups.default) {
        showFavourite = true;
    }
    else if (elementGroup === constants_1.patientProgramElementGroups.appointment) {
        showHomeNavigation = true;
        redirectHomeAfterLastTask = true;
    }
    return __assign(__assign({}, task), { taskLabels: (0, stringUtils_1.listFromCommaStrings)(task.label), elementId: element.id, taskName: element.task ? element.name : task.name, elementLabel: element.label, moduleName: element.module ? element.name || element.module.name : element.name, module: element.module, patientProgramId: patientProgramId, patientProgramElementId: element.id, elementIndex: elementIndex, elementGroup: elementGroup, currentTaskNr: Number(element.module ? subIndex : elementIndex), listLength: listLength, elementCompleted: element.completed, progress: listLength > 1 ? element.progress : null, showNextPrevNavigation: showNextPrevNavigation, showHomeNavigation: showHomeNavigation, hidePrevNavigationIfFirstTask: hidePrevNavigationIfFirstTask, saveAndAbortNavigation: saveAndAbortNavigation, redirectHomeAfterLastTask: redirectHomeAfterLastTask, showPopupAfterLastTask: showPopupAfterLastTask, showSideMenu: showSideMenu, showProgress: showProgress, showFavourite: showFavourite, showBackNavigation: showBackNavigation, isSeparateItemsInModule: isSeparateItemsInModule, showCompleteNavigation: showCompleteNavigation, isWorkSheet: isWorkSheet, isSubmitTask: isSubmitTask });
};
var getTask = function (programDetails, elementGroup, elementIndex, subIndex) {
    var _a;
    if (subIndex === void 0) { subIndex = 0; }
    if (!programDetails || !programDetails.groupedElements || !programDetails.groupedElements[elementGroup]) {
        return null;
    }
    var elementsInGroup = programDetails.groupedElements[elementGroup];
    var element = elementsInGroup[elementIndex];
    if (!element) {
        return null;
    }
    var task = ((_a = element.module) === null || _a === void 0 ? void 0 : _a.tasks) ? element.module.tasks[Number(subIndex)] : element.task;
    if (!task) {
        return null;
    }
    return getTaskWithDetails(element, task, programDetails.id, elementIndex, elementsInGroup.length, subIndex);
};
exports.getTask = getTask;
var getTaskFromElement = function (element, patientProgramId) {
    var _a;
    if (!element) {
        return null;
    }
    var task = ((_a = element.module) === null || _a === void 0 ? void 0 : _a.tasks) ? element.module.tasks[0] : element.task;
    if (!task) {
        return null;
    }
    return getTaskWithDetails(element, task, patientProgramId);
};
exports.getTaskFromElement = getTaskFromElement;
var getProgramContentLink = function (link, program) {
    if (!link || !program)
        return null;
    var _a = (0, taskContentUtils_1.parseInternalLink)(link), taskOrModuleId = _a.taskOrModuleId, hash = _a.hash;
    var _b = (0, taskContentUtils_1.getItemPositionInPatientProgram)(program, taskOrModuleId), elementGroup = _b.elementGroup, elementIndex = _b.elementIndex, taskIndex = _b.taskIndex;
    if (elementGroup && elementIndex > -1 && taskIndex > -1) {
        return "".concat(urls_1.default.inside.program, "/").concat(elementGroup, "/").concat(elementIndex, "/").concat(taskIndex).concat(hash);
    }
    if (elementGroup && elementIndex > -1) {
        return "".concat(urls_1.default.inside.program, "/").concat(elementGroup, "/").concat(elementIndex).concat(hash);
    }
    return "".concat(urls_1.default.inside.programLink, "/").concat(taskOrModuleId).concat(hash);
};
exports.getProgramContentLink = getProgramContentLink;
var getPublicProgramContentLink = function (link, program) {
    var _a = (0, taskContentUtils_1.parseInternalLink)(link), taskOrModuleId = _a.taskOrModuleId, hash = _a.hash;
    var _b = (0, taskContentUtils_1.getItemPositionInProgram)(program, taskOrModuleId), moduleIndex = _b.moduleIndex, taskIndex = _b.taskIndex;
    if (moduleIndex > -1 && taskIndex > -1) { // link is to taskId
        return "".concat(urls_1.default.public.program, "/").concat(program.id, "/").concat(moduleIndex, "/").concat(taskIndex).concat(hash);
    }
    if (moduleIndex > -1) { // link is to moduleId
        return "".concat(urls_1.default.public.program, "/").concat(program.id, "/").concat(taskOrModuleId).concat(hash);
    }
    return "".concat(urls_1.default.public.programLink, "/").concat(taskOrModuleId).concat(hash);
};
exports.getPublicProgramContentLink = getPublicProgramContentLink;
